'use client';

import { AppError } from '@/shared/presentation/components/app-error';

export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return <AppError {...props} />;
}
